function loadScripts(e) {
  if(e && !e.isTrusted){
    return;
  }


  // alert('hii')
    setTimeout(function () {
    // loadCSS('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css');
    loadScript("//www.wearcomet.com/cdn/shop/t/339/assets/hp-custom-script.js?v=138988952366681973331790872493");

    loadScript("//www.wearcomet.com/cdn/shop/t/339/assets/details-disclosure.js?v=153497636716254413831790872493");
    loadScript("//www.wearcomet.com/cdn/shop/t/339/assets/details-modal.js?v=4511761896672669691790872493");
    loadScript("//www.wearcomet.com/cdn/shop/t/339/assets/cart-notification.js?v=160453272920806432391790872493");
    loadScript("//www.wearcomet.com/cdn/shop/t/339/assets/cart-drawer-script.js?v=24308693613533450291790872494");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-slider.css?v=111384418465749404671790872494");

    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/customer.css?v=63738949733641882881790872494");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/popup.css?v=184015748029876475071790872494");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/fontfaces-interaction-hp.css?v=284869");
    
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-cart-drawer.css?v=15566466097704326981790872495");
    // loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/new-testimonial-carousel.css?v=89025444566313207841790872827"); // loaded eagerly in homepage-render-js-asset
    // loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/custom-mega-menu.css?v=51245767550190522631790872493"); // loaded eagerly in homepage-render-js-asset
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/section-footer.css?v=171161867995400310821790872495");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-newsletter.css?v=103472482056003053551790872494");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-list-menu.css?v=151968516119678728991790872495");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-list-payment.css?v=69253961410771838501790872495");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-list-social.css?v=52211663153726659061790872492");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/footer.css?v=87833187280690901731790872827");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-predictive-search.css?v=85913294783299393391790872493");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-search.css?v=184225813856820874251790872494");
    // loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-menu-drawer.css?v=108824014257386328241790872494");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-cart-notification.css?v=108833082844665799571790872492");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-cart-items.css?v=138827669520066067571790872495");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-price.css?v=130611431301202989081790872493");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-loading-overlay.css?v=167310470843593579841790872493");

    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-cart.css?v=61086454150987525971790872493");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-totals.css?v=86168756436424464851790872495");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-discounts.css?v=164788277903287711551790872494");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-loading-overlay.css?v=167310470843593579841790872493");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/lazy-video-styles.css?v=107481450961078042501790872493");
    loadCSS("//www.wearcomet.com/cdn/shop/t/339/assets/component-localization-form.css?v=173603692892863148811790872493");

    loadCSS("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css");

    

    // window.cartTypeDrawerLoaded = false;
    // if (window.cartTypeDrawer && !window.cartTypeDrawerLoaded) {
    //   let script = document.createElement('script');
    //   script.src = "//www.wearcomet.com/cdn/shop/t/339/assets/cart-drawer.js?v=68401610320305176801790872493";
    //   script.defer = true;
    //   script.setAttribute('data-ajaxloader-eval', 'false');
    //   document.body.appendChild(script);
    //   window.cartTypeDrawerLoaded = true;
    // }

    window.countrySelectorLoaded = false;
    if (window.countrySelector && !window.countrySelectorLoaded) {
      var script = document.createElement('script');
      script.src = "//www.wearcomet.com/cdn/shop/t/339/assets/localization-form.js?v=131562513936691783521790872494";
      script.defer = true;
      document.body.appendChild(script);
      window.countrySelectorLoaded = false;
    }

    // loadScriptWithCallBack('https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js', function(){

      const testiSwiper = new Swiper('.hp-testimonial-container', {
        slidesPerView: 1,
        spaceBetween: 30,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.testimonial-next',
          prevEl: '.testimonial-prev',
        },
        on: {
          init: function() {
            if(window.innerWidth <= 1000){
              var maxHeight = 0;
              document.querySelectorAll('.hp-testimonial-container .swiper-slide').forEach(function(slide) {
                maxHeight = Math.max(maxHeight, slide.offsetHeight);
              });
              document.querySelectorAll('.hp-testimonial-container .swiper-slide').forEach(function(slide) {
                slide.style.height = maxHeight + 'px';
                // document.querySelector('.hp-testimonial-container .swiper-wrapper').style.height = maxHeight + 'px';
                slide.querySelector('.testimonial-inner-block').style.height = maxHeight - 44 + 'px';

              });
            }
          }
        },
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        breakpoints: {
          1000: {
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            spaceBetween: 38
          },

          750: {
            slidesPerView: 1.1,
            slidesPerGroup: 1,
            spaceBetween: 30
          }
        }
      });


    // document.getElementById('dev_annoucement-bar-slick-placeholder').style.display = 'none';


    document.querySelectorAll('.placeholder-slk-prnt').forEach(el => {
      el.style.opacity = '0';
    });

    document.querySelectorAll('.onrendered-slider-prnt').forEach(el => {
      el.style.opacity = '1';
    });

    
  // loadScript("//www.wearcomet.com/cdn/shop/t/339/assets/global.js?v=181528720732402970781790872495");
  loadScript("//www.wearcomet.com/cdn/shop/t/339/assets/quick-add-to-cart.js?v=149215956464844627301790872494");


    
  }, 10);


  // Remove event listeners after scripts are loaded
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mousemove', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

// Check if the user is beyond 400px from the top
if (window.scrollY >= 400 || window.__openCartDrawer) {
  loadScripts();
} else {
  document.addEventListener('mousemove', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}